<div class="modal-overlay" *transloco="let t; prefix: 'driverInformation.settings'">
  <div class="modal-content">
    <div class="title">
      <h2>{{ t('title') }}</h2>
    </div>

    @if (!isLoading && settingsForm) {
    <form [formGroup]="settingsForm" (ngSubmit)="saveChangesAsync()">
      <div class="form-row">
        <div class="form-group">
          <div class="shift-time-toggle">
            <input 
              type="checkbox" 
              id="shiftTimeToggle"
              class="toggle-checkbox" 
              [checked]="settingsForm?.get('isShiftTimeEnabled')?.value"
              (change)="toggleShiftTimeEnabled()">
            <label for="shiftTimeToggle" class="toggle-button" [class.active]="settingsForm?.get('isShiftTimeEnabled')?.value"></label>
            <span class="toggle-label">{{ t('useShiftTime') }}</span>
          </div>
        </div>
        <div class="form-group">
          <label>{{ t('shiftStartEnd') }}</label>
          <div class="input-container">
            <input 
              type="text" 
              class="pointer" 
              formControlName="workingHours" 
              (click)="toggleTimeModal()" 
              readonly 
              [placeholder]="!settingsForm?.get('isShiftTimeEnabled')?.value ? '00:00 - 00:00' : t('shiftStartEndPlaceholder')"
              [disabled]="!settingsForm?.get('isShiftTimeEnabled')?.value"
              [class.disabled-bg]="!settingsForm?.get('isShiftTimeEnabled')?.value"/>
            <img src="assets/icons/icon-clock.svg" alt="hour glass" class="input-icon clock-icon">
            @if (isTimeModalOpen) {
            <div class="time-modal">
              <h3>{{ t('enterTime') }}</h3>
              <div class="form-row">
                <div class="form-group">
                  <label>{{ t('shiftStart') }}</label>
                  <div>
                    <input type="text" class="time-input" formControlName="startTime" [format]="24" [ngxTimepicker]="startPicker" readonly/>
                    <ngx-material-timepicker 
                      #startPicker 
                      [cancelBtnTmpl]="cancelBtn">
                    </ngx-material-timepicker>
                    <ng-template #cancelBtn>
                      <button class="custom-cancel-button">{{ 'common.cancel' | transloco }}</button>
                    </ng-template>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{ t('shiftEnd') }}</label>
                  <div>
                    <input type="text" class="time-input" formControlName="endTime" [format]="24" [ngxTimepicker]="endPicker" readonly/>
                    <ngx-material-timepicker 
                      #endPicker 
                      [cancelBtnTmpl]="cancelBtn">
                    </ngx-material-timepicker>
                    <ng-template #cancelBtn>
                      <button class="custom-cancel-button">{{ 'common.cancel' | transloco }}</button>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="time-button-group">
                <button class="cancel-btn" (click)="toggleTimeModal()">{{ 'common.discard' | transloco }}</button>
                <button class="save-btn" (click)="saveTimeChanges()" [disabled]="!isValidTimeRange()">{{ 'common.ok' | transloco }}</button>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>{{ t('hourlyRate') }}</label>
          <div class="input-container">
            <span class="currency-prefix">{{ t('currencyPrefix') }}</span>
            <input class="amount-input" type="text" formControlName="hourlyRate" required />
          </div>
        </div>
        <div class="form-group">
          <label>{{ t('shiftDuration') }}
            @if (settingsForm?.get('isShiftTimeEnabled')?.value) {
            <svg [ngbTooltip]="t('shiftDurationTooltip')" placement="top"
            xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" style="margin-left: 4px; vertical-align: middle; display: inline-block;">
            <circle cx="8" cy="8" r="7" fill="none" stroke="#4D4749" stroke-width="2" />
            <line x1="8" y1="12" x2="8" y2="8" stroke="#4D4749" stroke-width="2" />
            <circle cx="8" cy="5" r="1" fill="#4D4749" />
          </svg>
            }
        </label>
          <div class="input-container">
            <app-duration-picker-input 
              [formControlName]="'shiftDuration'" 
              [required]="true"
              [disabled]="settingsForm?.get('isShiftTimeEnabled')?.value">
            </app-duration-picker-input>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>{{ t('daysIn') }}</label>
          <div class="input-container">
            <input type="text" formControlName="daysIn" type="number" min="1">
          </div>
        </div>
        <div class="form-group">
          <label>{{ t('daysOff') }}</label>
          <div class="input-container">
            <input type="text" formControlName="daysOff" type="number" min="1" />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <app-flatpickr-date-picker
            [label]="t('shiftStartDate')"
            [(value)]="shiftStartDate"
            [allowPastDates]="true">
          </app-flatpickr-date-picker>
        </div>
        <div class="form-group">
          <label>{{ t('standardRate') }}</label>
          <div class="input-container">
            <input type="text" formControlName="standardRate" />
            <img src="assets/icons/icon-hour-glass.svg" alt="hour glass" class="input-icon">
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>{{ t('saturdayRate') }}</label>
          <div class="input-container">
            <input type="text" formControlName="saturdayRate" />
            <img src="assets/icons/icon-hour-glass.svg" alt="hour glass" class="input-icon">
          </div>
        </div>
        <div class="form-group">
          <label>{{ t('holidayRate') }}</label>
          <div class="input-container">
            <input type="text" formControlName="holidayRate" />
            <img src="assets/icons/icon-hour-glass.svg" alt="hour glass" class="input-icon">
          </div>
        </div>
      </div>
      <div class="button-group form-group">
        <button type="button" class="cancel-btn" (click)="close()">{{ 'common.cancel' | transloco }}</button>
        <button type="submit" class="save-btn" (click)="saveChangesAsync()" [disabled]="isLoading || !settingsForm.valid">{{ 'common.saveChanges' | transloco }}</button>
      </div>
    </form>
    }
    @if (isLoading) {
    <div>
      <div class="loader">
        <span class="spinner-border"></span>
      </div>
    </div>
    }
  </div>
</div>